<!--
<div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
  <h4 class="form-modal-title">{{ formName }}</h4>
</div> -->

<!-- <div class="form-modal-body p-3"> -->
<div [style.display]="isResolveMode() ? 'none' : 'block'" class="internaldeficicencysection">
<formio *ngIf="[true,false].includes(isShowForm) ? isShowForm : formJson && isVisible" [submission]="submittedData" [form]="formJson" [renderOptions]="renderOptions"
  (submit)="onSubmit($event)" [readOnly]="viewForm || readOnly" [options]="formOptions" #formIO>
</formio>
</div>
<!-- </div> -->

<!-- Loading state -->
<div *ngIf="isLoading && isVisible" class="text-center p-4">
  <i class="fa fa-spinner fa-spin"></i> Loading grid...
</div>


<ng-container *ngIf="!isLoading && gridItems && gridConfig && gridConfig.length > 0">
  <div class="pageWrapper gridview">
    <div class="d-flex w-100 justify-content-end mb-10 licenseactions" *ngIf="[true,false].includes(isShowForm) ? isShowForm : isVisible && !isResolveMode()">
      <button class="btn-cancel btn text-right py-1" [pTooltip]="'Reset'" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onReset()"
        id="btn_custom_grid_reset" [disabled]="readOnly" >Reset</button>
      <button type="button" [disabled]="isDisable  || readOnly" class="btn btn-primary grid rounded btn-add" aria-label="Add" pRipple
        [pTooltip]="buttonLabel ? buttonLabel : 'Add'" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onSubmit(submittedData)"
        id="btn_custom_grid_{{buttonLabel}}"> <i class="pi pi-plus-circle"></i> {{buttonLabel}}</button>
    </div>
  <div class="pageWrapper gridview licenseendorsementgrid">
    <dx-data-grid #dataGrid [dataSource]="gridItems" [showBorders]="true" [rowAlternationEnabled]="false"
      [columnAutoWidth]="true" [wordWrapEnabled]="true" [allowColumnResizing]="true" [columnResizingMode]="'widget'"
      [width]="'100%'" [columnMinWidth]="80"
      (onRowPrepared)="onRowPrepared($event)"
      (onSelectionChanged)="onSelectionChanged($event)" (onContentReady)="setActionColumnWidth($event)">
      <dxo-search-panel [visible]="true" placeholder="Search..." [highlightCaseSensitive]="false"></dxo-search-panel>
      <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-paging [pageSize]="10"></dxo-paging>
      <dxo-sorting mode="multiple"></dxo-sorting>
      <dxo-scrolling  mode="standard" showScrollbar="always" useNative="true"></dxo-scrolling>
      <dxo-pager [visible]="true" [allowedPageSizes]="[5, 10, 20]" [showPageSizeSelector]="true"
        [showNavigationButtons]="true" [showInfo]="true" [displayMode]="displayMode"></dxo-pager>
      <ng-container *ngFor="let column of gridConfig; let i = index">
        <ng-container *ngIf="column.hide !== true">
          <ng-container *ngIf="column.link; else noLink">
            <dxi-column [dataField]="column.columnDef" [caption]="column.header" [allowFiltering]="column.filter"
              [cellTemplate]="column.isFirstVisibleColumn ? 'firstColumnTemplate' : 'cellTemplate'"></dxi-column>
          </ng-container>
          <ng-template #noLink>
            <ng-container *ngIf="column.header?.includes('Status'); else noStatus">
          <dxi-column [dataField]="column.columnDef" [caption]="column.header" [allowFiltering]="column.filter" cellTemplate="statusCell"></dxi-column>
          </ng-container>
          </ng-template>
          <ng-template #noStatus>
            <ng-container *ngIf="column.icon; else noIcon">
              <dxi-column [dataField]="column.columnDef" [caption]="column.header" [allowFiltering]="column.filter"
                [cellTemplate]="column.isFirstVisibleColumn ? 'firstColumnIconTemplate' : 'iconTemplate'"></dxi-column>
            </ng-container>
          </ng-template>
          <ng-template #noIcon>
            <ng-container *ngIf="column.dateFormat; else noDate">
              <dxi-column *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                [dataField]="column.columnDef" [caption]="column.header" [allowFiltering]="column.filter"
                [dataType]="'date'" format="MM/dd/yyyy" [cellTemplate]="column.isFirstVisibleColumn ? 'firstColumnDateTemplate' : null">
              </dxi-column>
            </ng-container>
          </ng-template>
          <ng-template #noDate>
            <ng-container *ngIf="column.isHtml; else noNotes">
          <dxi-column [dataField]="column.columnDef" [caption]="column.header" [allowFiltering]="column.filter" cellTemplate="htmlCellTemplate" [cssClass]="'max-width-col-2'"></dxi-column>
          </ng-container>
          </ng-template>
          <ng-template #noNotes>
            <dxi-column [dataField]="column.columnDef" [caption]="column.header" [allowFiltering]="column.filter" [cssClass]="'max-width-col-2'"
              [cellTemplate]="column.isFirstVisibleColumn ? 'firstColumnDefaultTemplate' : null">
            </dxi-column>
          </ng-template>
        </ng-container>
      </ng-container>
      <dxi-column *ngIf="((isVisible || isActionVisible) && !isResolveMode()) || hasAnyResolutionAction()" caption="Actions" [width]="gridItems?.length > 0 ? actionColumnWidth : 80"
        [allowSorting]="false" cellTemplate="actionsTemplate" [fixed]="gridItems?.length > 0" fixedPosition="right" cssClass="action-column"></dxi-column>
      <dxo-scrolling mode="standard" showScrollbar="onHover" [useNative]="false"></dxo-scrolling>
      <dxo-cell-hint [enabled]="false"></dxo-cell-hint>
      <div *dxTemplate="let data of 'actionsTemplate'" class="custom-grid-actioncontainer">
        <button class="action-icon-button"
          *ngIf="!isResolveMode() && onShowAction(data.data, 'edit') && shouldShowActionType(data.data, 'edit')"
          pTooltip="Edit" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onEdit(data)">
          <span class="sr-only">Edit</span>
          <span class="material-symbols-outlined">edit_square</span>
        </button>
        <button class="action-icon-button"
          *ngIf="!isResolveMode() && onShowAction(data.data, 'view') && shouldShowActionType(data.data, 'view')"
          pTooltip="View" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onView(data)">
          <span class="sr-only">View</span>
          <span class="material-symbols-outlined">visibility</span>
        </button>
        <button class="action-icon-button deletebtn"
          *ngIf="!isResolveMode() && onShowAction(data.data, 'delete') && shouldShowActionType(data.data, 'delete')"
          pTooltip="Delete" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onDelete(data, deleteModel)">
          <span class="sr-only">Delete</span>
          <span class="material-symbols-outlined material-delete-symbol">delete</span>
        </button>
        <!-- <button class="fa fa-check-circle ml-1"
          *ngIf="shouldShowActionsForItem(data.data) && isShowMarkAsAddressed === true && data?.data?.notes_type === 'Deficiency' &&  (!data?.data?.review_status || data?.data?.review_status === 'Deficient' || data?.data?.review_status === 'Pending Review')"
          pTooltip="Mark as Addressed" tooltipPosition="bottom"
          (click)="onMarkAsAddressed(data, confirmAddressedModel)">
          <span class="sr-only">Mark as Addressed</span>
        </button> -->
        <button class="action-icon-button activate-btn"
          *ngIf="!isResolveMode() && shouldShowActionsForItem(data.data) && onShowAction(data.data, 'markasaddressed')"
          pTooltip="Mark as Addressed" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
          (click)="onMarkAsAddressed(data, confirmAddressedModel)">
          <span class="sr-only">Mark as Addressed</span>
          <span class="material-symbols-outlined">verified_user</span>
        </button>
        <!-- <button class="fa fa-solid fa-eye ml-1"
          *ngIf="shouldShowActionsForItem(data.data) && isShowViewDeficiencyNotes === true && data?.data?.notes_type === 'Deficiency' && data?.data?.review_status === 'Addressed'"
          pTooltip="View Deficiency Resolution Notes" tooltipPosition="bottom"
          (click)="onViewAddressedNotes(data,viewDeficiencyNotes)">
          <span class="sr-only">View Deficiency Resolution Notes</span>
        </button> -->
        <button class="action-icon-button"
          *ngIf="!isResolveMode() && shouldShowActionsForItem(data.data) && onShowAction(data.data, 'viewaddressednotes')"
          pTooltip="View Deficiency Resolution Notes" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
          (click)="onViewAddressedNotes(data,viewDeficiencyNotes)">
          <span class="sr-only">View Deficiency Resolution Notes</span>
          <span class="material-symbols-outlined material-symbols-viewdeficicency">comment</span>
        </button>
        <!-- <button class="fa fa-check ml-1"
          *ngIf="shouldShowActionsForItem(data.data) && isShowMarkAsValid === true && data?.data?.notes_type === 'Deficiency' && data?.data?.review_status === 'Addressed'"
          pTooltip="Mark as Valid" tooltipPosition="bottom" (click)="onMarkAsValid(data, confirmValidationModel)">
          <span class="sr-only">Mark as Valid</span>
        </button> -->
        <button class="action-icon-button  activate-btn"
          *ngIf="!isResolveMode() && shouldShowActionsForItem(data.data) && onShowAction(data.data, 'markasvalid')"
          pTooltip="Mark as Valid" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onMarkAsValid(data, confirmValidationModel)">
          <span class="sr-only">Mark as Valid</span>
          <span class="material-symbols-outlined material-mark-icon">verified</span>
        </button>
        <!-- <button class="fa fa-exclamation-triangle ml-1"
          *ngIf="shouldShowActionsForItem(data.data) && isShowMarkAsDeficient === true && data?.data?.notes_type === 'Deficiency' && data?.data?.review_status === 'Addressed'"
          pTooltip="Mark as Deficient" tooltipPosition="bottom"
          (click)="onMarkAsDeficient(data, confirmDeficiencyModel)">
          <span class="sr-only">Mark Deficient</span>
        </button> -->
        <button class="action-icon-button warning-btn"
          *ngIf="!isResolveMode() && shouldShowActionsForItem(data.data) && onShowAction(data.data, 'markasdeficient')"
          pTooltip="Mark as Deficient" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
          (click)="onMarkAsDeficient(data, confirmDeficiencyModel)">
          <span class="sr-only">Mark Deficient</span>
          <span class="material-symbols-outlined material-warn-symbol">warning</span>
        </button>
        <button class="action-icon-button transcript-btn"
          *ngIf="!readOnly && !isResolveMode() && shouldShowTranscriptAction(data.data)"
          pTooltip="Mark Transcript Received" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
          (click)="onMarkTranscriptReceived(data, confirmTranscriptModel)">
          <span class="sr-only">Mark Transcript Received</span>
          <span class="material-symbols-outlined">order_approve</span>
        </button>

        <button class="action-icon-button resolution-btn"
          *ngIf="!readOnly && shouldShowRequestResolution(data.data)"
          pTooltip="Request Resolution" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
          (click)="onRequestResolution(data, requestResolutionModel)">
          <span class="sr-only">Request Resolution</span>
          <img src="assets/images/neveda-images/request_resolution.svg" alt="Request Resolution" class="action-icon-svg icon-default" />
          <img src="assets/images/neveda-images/active_request_resolution.svg" alt="Request Resolution" class="action-icon-svg icon-active" />
        </button>

        <button class="action-icon-button cancel-resolution-btn"
          *ngIf="!readOnly && shouldShowCancelResolution(data.data)"
          pTooltip="Cancel Request Resolution" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
          (click)="onCancelResolution(data, cancelResolutionModel)">
          <span class="sr-only">Cancel Request Resolution</span>
          <img src="assets/images/neveda-images/cancel_request_resolution.svg" alt="Cancel Request Resolution" class="action-icon-svg icon-default" />
          <img src="assets/images/neveda-images/active_cancel_request_resolution.svg" alt="Cancel Request Resolution" class="action-icon-svg icon-active" />
        </button>

        <button class="action-icon-button view-resolution-notes-btn"
          *ngIf="shouldShowViewResolutionNotes(data.data)"
          pTooltip="View Resolution Notes" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
          (click)="onViewResolutionNotes(data, viewResolutionNotesModel)">
          <span class="sr-only">View Resolution Notes</span>
          <span class="material-symbols-outlined">comment</span>
        </button>

        <button class="action-icon-button"
        *ngIf="!isResolveMode() && onShowAction(data.data, 'viewdeficiencynotes')"
          pTooltip="View Deficient Notes" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
          (click)="onViewDeficientComments(data, viewDeficiencyModel)">
          <span class="sr-only">View Deficient Notes</span>
          <span class="material-symbols-outlined material-warn-symbol material-deficiency-icon">comment</span>
        </button>


      </div>
      <div *dxTemplate="let d of 'cellTemplate'">
        <span href="javascript:void(0)" *ngIf="d.value && d.value !== 'null'" class="link-data"
          (click)="getRouter(d)">{{
          d.value !== 'null' ? d.value : ''
          }}</span>
        <img src="assets/images/neveda-images/visual_indicator.svg" class="new-item-star" *ngIf="d.columnIndex === 0 && shouldShowNewItemStar(d.data)" title="New Item" alt="New Item" />
      </div>
      <div *dxTemplate="let d of 'htmlCellTemplate'">
          <span *ngIf="containsHtml(d.value)">{{ d.value | stripHtml }}</span>
          <span *ngIf="!containsHtml(d.value)">{{ d.value }}</span>
      </div>

      <ng-container *ngIf="updateGrid.linkVisible">
        <div *dxTemplate="let d of 'cellTemplate'">
          <span *ngIf="d.value && d.value !== 'null'" #contentWrapper [innerHTML]="d.value | safeHtml">{{
            d.value !== 'null' ? d.value : ''
            }}</span>
        </div>
      </ng-container>
      <div *dxTemplate="let d of 'iconTemplate'">
        <em class="fa fa-book"></em>
      </div>
      <div *dxTemplate="let d of 'firstColumnTemplate'">
        <span href="javascript:void(0)" *ngIf="d.value && d.value !== 'null'" class="link-data"
          (click)="getRouter(d)">{{d.value !== 'null' ? d.value : ''}}</span>
        <img src="assets/images/neveda-images/visual_indicator.svg" class="new-item-star" *ngIf="d.columnIndex === 0 && shouldShowNewItemStar(d.data)" title="New Item" alt="New Item" />
      </div>
      <div *dxTemplate="let d of 'firstColumnIconTemplate'">
        <em class="fa fa-book"></em>
        <img src="assets/images/neveda-images/visual_indicator.svg" class="new-item-star" *ngIf="shouldShowNewItemStar(d.data)" title="New Item" alt="New Item" />
      </div>
      <div *dxTemplate="let d of 'firstColumnDateTemplate'">
        <span>{{ d.value | date: 'MM/dd/yyyy' }}</span>
        <img src="assets/images/neveda-images/visual_indicator.svg" class="new-item-star" *ngIf="shouldShowNewItemStar(d.data)" title="New Item" alt="New Item" />
      </div>
      <div *dxTemplate="let d of 'firstColumnDefaultTemplate'">
        <span>{{ d.value }}</span>
        <img src="assets/images/neveda-images/visual_indicator.svg" class="new-item-star" *ngIf="shouldShowNewItemStar(d.data)" title="New Item" alt="New Item" />
      </div>
      <div *dxTemplate="let cell of 'statusCell'">
          <div class="status-cell">
            <span class="status-badge" [ngClass]="statusClass(cell?.value)">
              <span class="dot"></span>
              {{ cell?.value ||'-' }}
            </span>
          </div>
      </div>
    </dx-data-grid>
  </div>
  <ng-template #deleteModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
      <h4 class="form-modal-title">{{ deleteAction.title }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="closePopup()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-modal-body p-3">
      <p class="delete-content">{{ deleteAction.content }}</p>
    </div>
    <!-- <div class="form-modal-footer">
      <p-button label="Yes" styleClass="px-3 py-1" (click)="onDeleteItem()"></p-button>
      <p-button label="No" styleClass="btn-cancel px-3 py-1 mr-2 " (click)="closePopup()"> </p-button>
    </div> -->
    <div class="form-modal-footer p-3">
      <div class="justify-content-center modal-actions">
        <button class="btn-cancel btn btn-primary btn-md px-3 py-1" (click)="closePopup()">Cancel</button>
        <button lang="en" class="btn btn-primary btn-md deletebtn " (click)="onDeleteItem()"
          ref="button">Delete</button>
      </div>
    </div>
  </ng-template>


  <ng-template #confirmAddressedModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
      <h4 class="form-modal-title">Mark Deficiency as Addressed</h4>
      <button type="button" class="close" aria-label="Close" (click)="closePopup()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-modal-body p-3">
      <p class="delete-content">Please add a short note explaining how you addressed this deficiency. <span class="text-danger">*</span></p>
      <textarea class="form-control mt-2" rows="4" placeholder="Enter Notes" [(ngModel)]="actionText"
        name="actionText" #actionTextRef="ngModel" required>
</textarea>
    <div class="mt-2 text-danger" *ngIf="actionTextRef.errors?.required && actionTextRef.dirty">
     Note is required.
    </div>
    <div class="text-danger"  *ngIf="wordCount > 100"> Maximum 100 words allowed.</div>
    </div>

    <div class="form-modal-footer p-3">
      <div class="justify-content-center modal-actions">
        <button class="btn-cancel btn btn-primary btn-md px-3 py-1" (click)="closePopup()">Cancel</button>
        <button lang="en" class="btn btn-primary btn-md" (click)="onMarkAsAddressedItem()"
          [disabled]="actionTextRef.invalid || wordCount > 100">
          Proceed
        </button>

      </div>
    </div>
  </ng-template>


  <ng-template #confirmValidationModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
      <h4 class="form-modal-title">Confirm Validation</h4>
      <button type="button" class="close" aria-label="Close" (click)="closePopup()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-modal-body p-3">
      <p class="delete-content">This will mark the document as valid, indicating it has been reviewed and found
        satisfactory.</p>
    </div>
    <div class="form-modal-footer p-3">
      <div class="justify-content-center modal-actions">
        <button class="btn-cancel btn btn-primary btn-md px-3 py-1" (click)="closePopup()">Cancel</button>
        <button lang="en" class="btn btn-primary btn-md " (click)="onMarkAsValidItem()" ref="button">Proceed</button>
      </div>
    </div>
  </ng-template>


  <ng-template #confirmDeficiencyModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
      <h4 class="form-modal-title">Confirm Deficiency</h4>
      <button type="button" class="close" aria-label="Close" (click)="closePopup()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-modal-body p-3">
      <p class="delete-content">This will mark the record as deficient, indicating it has been reviewed and requires
        correction or additional information.</p>

      <label class="mb-0" for="deficiencyNotes">Deficiency Notes <span class="text-danger">*</span></label>
      <p-editor id="deficiencyNotes" [(ngModel)]="actionText"
                name="actionText"
                [style]="{ height: '150px' }"
                placeholder="Enter External Deficiency Comments"
                #actionTextRef="ngModel" required
                >
            </p-editor>
        <div class="text-danger mt-2" *ngIf="actionTextRef.errors?.required && actionTextRef.dirty">
          External Deficiency Comments are required to preview.
      </div>
  </div>
  <div class="form-modal-footer p-3">
    <div class="justify-content-center modal-actions">
      <button class="btn-cancel btn btn-primary btn-md px-3 py-1" (click)="closePopup()">Cancel</button>

      <button lang="en" class="btn btn-primary btn-md" [disabled]="actionTextRef.invalid" (click)="onMarkAsDeficientItem()">
        Proceed
      </button>

    </div>
  </div>
</ng-template>

  <ng-template #viewDeficiencyModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
      <h4 class="form-modal-title">Deficiency Notes</h4>
      <button type="button" class="close" aria-label="Close" (click)="closePopup()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-modal-body p-3">
      <label class="mb-0" for="deficiencyNotes">Deficiency Notes <span class="text-danger">*</span></label>
        <div id="deficiencyNotes"
          class="form-control rich-text-viewer"
          [innerHTML]="viewNotesText">
      </div>
  </div>
</ng-template>

 <ng-template #viewDeficiencyNotes let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
      <h4 class="form-modal-title">Mark Deficiency as Addressed</h4>
      <button type="button" class="close" aria-label="Close" (click)="closePopup()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-modal-body p-3">
      <p class="delete-content">Please add a short note explaining how you addressed this deficiency. <span class="text-danger">*</span></p>
      <textarea class="form-control mt-2" rows="4" placeholder="Enter Notes" [(ngModel)]="actionText"
        name="actionText" #actionTextRef="ngModel" required readonly>
</textarea>
    <!-- <div class="text-danger" *ngIf="actionTextRef.errors?.required && actionTextRef.dirty">
     Please enter a note.
    </div>
    <div class="text-danger"  *ngIf="wordCount > 100"> Maximum 100 words allowed.</div> -->
    </div>

    <div class="form-modal-footer p-3">
      <div class="justify-content-center modal-actions">
        <button class="btn-cancel btn btn-primary btn-md px-3 py-1" (click)="closePopup()">Cancel</button>
        <!-- <button lang="en" class="btn btn-primary btn-md" (click)="onMarkAsAddressedItem()"
          [disabled]="actionTextRef.invalid">
          Proceed
        </button> -->

      </div>
    </div>
  </ng-template>

  <ng-template #confirmTranscriptModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
      <h4 class="form-modal-title">Mark Transcript Received</h4>
      <button type="button" class="close" aria-label="Close" (click)="closePopup()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-modal-body p-3">
      <p class="delete-content" [innerHTML]="transcriptMessage"></p>
    </div>
    <div class="confirm-removal-footer">
        <button class="confirm-removal-btn-cancel" (click)="closePopup()">Cancel</button>
        <button class="confirm-removal-btn-confirm" (click)="onConfirmTranscript()">Confirm</button>
    </div>
  </ng-template>

  <ng-template #requestResolutionModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
      <h4 class="form-modal-title">Request Resolution</h4>
      <button type="button" class="close" aria-label="Close" (click)="closePopup()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-modal-body p-3">
      <label class="mb-1" for="resolutionNotes">Please describe the updates you have made to address <span class="font-weight-bold font-italic">{{ resolutionProvisionValue }}</span>. <span class="text-danger">*</span></label>
      <textarea class="form-control mt-2" rows="4" id="resolutionNotes"
        placeholder="Enter Notes"
        [ngModel]="resolutionNotes"
        (ngModelChange)="onResolutionNotesChange($event)"
        maxlength="4000"
        [class.is-invalid]="resolutionNotesRef.touched && resolutionNotesRef.errors?.required"
        name="resolutionNotes" #resolutionNotesRef="ngModel" required>
      </textarea>
      <div class="text-danger mt-1" *ngIf="resolutionNotesRef.touched && resolutionNotesRef.errors?.required">
        Notes are required.
      </div>
      <p class="mt-3 resolution-info-text">
        Before submitting your application, ensure all relevant application sections have been updated and any supporting documentation has been provided.
      </p>
    </div>
    <div class="confirm-removal-footer">
        <button class="confirm-removal-btn-cancel" (click)="closePopup()">Cancel</button>
        <button class="confirm-removal-btn-confirm" [disabled]="resolutionNotesInvalid" (click)="onConfirmRequestResolution()">Proceed</button>
    </div>
  </ng-template>

  <ng-template #cancelResolutionModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
      <h4 class="form-modal-title">Cancel Resolution Request</h4>
      <button type="button" class="close" aria-label="Close" (click)="closePopup()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-modal-body p-3">
      <p class="delete-content">Are you sure you want to cancel your resolution request for <span class="font-weight-bold font-italic">{{ resolutionProvisionValue }}</span>?</p>
    </div>
    <div class="confirm-removal-footer">
        <button class="confirm-removal-btn-cancel" (click)="closePopup()">Cancel</button>
        <button class="confirm-removal-btn-confirm" (click)="onConfirmCancelResolution()">Proceed</button>
    </div>
  </ng-template>

  <ng-template #viewResolutionNotesModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
      <h4 class="form-modal-title">Resolution Notes</h4>
      <button type="button" class="close" aria-label="Close" (click)="closePopup()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-modal-body p-3">
      <label class="mb-1">Please describe the updates you have made to address <span class="font-weight-bold font-italic">{{ resolutionProvisionValue }}</span>.</label>
      <div class="form-control mt-2 view-resolution-notes-box">{{ viewResolutionNotesText }}</div>
    </div>
    <div class="confirm-removal-footer">
        <button class="confirm-removal-btn-cancel" (click)="closePopup()">Close</button>
    </div>
  </ng-template>

</div>
</ng-container>

<!-- Remove All Items Confirmation Popup -->
<div class="confirm-removal-overlay" *ngIf="showRemoveConfirmPopup">
  <div class="confirm-removal-modal">
    <div class="confirm-removal-header">
      <h3 class="confirm-removal-title">Confirm Data Removal</h3>
      <button type="button" class="confirm-removal-close" aria-label="Close" (click)="closeRemoveConfirmPopup()">
        &times;
      </button>
    </div>
    <div class="confirm-removal-body">
      <p class="confirm-removal-text">
        You have changed your response to <strong>{{ questionLabel }}</strong> to <strong>No</strong>. All information previously entered for this question will be removed from your application.
        <br><br>
        This may include associated table entries, uploaded supporting documents, and any calculated totals related to this section.
        <br><br>
        This action cannot be undone.
        <br><br>
        Do you want to continue?
      </p>
    </div>
    <div class="confirm-removal-footer">
      <button class="confirm-removal-btn-cancel" (click)="closeRemoveConfirmPopup()">Cancel</button>
      <button class="confirm-removal-btn-confirm" (click)="onConfirmRemoveAllItems()">Confirm</button>
    </div>
  </div>
</div>
